import { render, staticRenderFns } from "./Coordonnees.vue?vue&type=template&id=a7073000&"
import script from "./Coordonnees.vue?vue&type=script&lang=js&"
export * from "./Coordonnees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports